module.exports = __webpack_public_path__ + "img/2.64aecbd7.jpg";